import * as browserUniversal from './browser';

export * from './browser';

export default browserUniversal;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
